var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.presentation.renewed)?_c('service-intro'):_c('legacy-service')}
var staticRenderFns = []

export { render, staticRenderFns }